import { render, staticRenderFns } from "./ForgottenPasswordStep2.vue?vue&type=template&id=41c38c7a&"
import script from "./ForgottenPasswordStep2.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordStep2.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPasswordStep2.vue?vue&type=style&index=0&id=41c38c7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports